import { getPeriodLevels } from "backend/model/getPeriodLevels";
import { getPeriods } from "backend/model/getPeriods";
import { IPeriodLevel } from "backend/model/model";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";

const usePeriodLevels = (periodLevel?: string) => {
  const ctx = useAppContext();
  return useQuery<IPeriodLevel[]>(
    `periodlevel-${ctx.modelId}-${periodLevel || ""}`,
    async () => {
      const levels = await getPeriodLevels(ctx.fullModelId || "");
      const periods = (await getPeriods(ctx.fullModelId || ""))
        .filter((p) => {
          if (periodLevel) {
            if (p.periodlevel === periodLevel) return true;
            return false;
          }
          return true;
        })
        .sort((a, b) => a.startdate.localeCompare(b.startdate));

      return levels.map((level) => {
        return {
          id: level.id,
          name: level.name,
          periods: periods.filter((p) => p.periodlevel === level.id),
        };
      });
    },
    {
      enabled: true,
      cacheTime: 30 * (60 * 1000),
      staleTime: 30 * (60 * 1000),
    }
  );
};

export default usePeriodLevels;
